import { View } from "@react-pdf/renderer";

type PageContentProps = View["props"];

const PageContent: React.FC<PageContentProps> = (props) => {
  const { children, style } = props;

  return (
    <View style={{ paddingTop: 40, paddingHorizontal: 60, gap: 20, ...style }}>{children}</View>
  );
};

export default PageContent;
